export default "__VITE_ASSET__HZXclCmf__"